import { createSlice } from '@reduxjs/toolkit';
import { getApplication } from 'shared/redux/applicationSlice';
import { clearPlantDesignForm } from 'plantItemNew/redux/slices/formSlice';

const initialState = {
  firstName: undefined,
  midddleName: undefined,
  lastName: undefined,
  emailAddress: undefined,
  employer: undefined,
  jobTitle: undefined,
  isCompleted: false,
};

const plantDesignApplicantDetailsSlice = createSlice({
  name: 'plantDesignApplicantDetails',
  initialState,
  reducers: {
    storePlantDesignApplicantDetails(state, action) {
      const applicantDetails = action.payload;
      return { ...applicantDetails };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(clearPlantDesignForm, () => {
        return initialState;
      })
      .addCase(getApplication.fulfilled, (state, action) => {
        return { ...action.payload.applicationData.plantDesignApplicantDetails };
      });
  },
});

export const { storePlantDesignApplicantDetails } = plantDesignApplicantDetailsSlice.actions;
export const plantDesignApplicantDetailsReducer = plantDesignApplicantDetailsSlice.reducer;
